const CreateScreen = ({ playerName, setPlayerName, onSubmit, onBack, error }) => (
  <div className="card">
    <div className="logo-tag">Create Room</div>
    <h1>Host a <span className="accent">Match</span></h1>

    {error && <div className="error-box">⚠️ {error}</div>}

    <div className="input-group">
      <label>Your Name</label>
      <input
        value={playerName}
        onChange={e => setPlayerName(e.target.value)}
        placeholder="Enter your name"
        autoFocus
        onKeyDown={e => e.key === "Enter" && onSubmit()}
      />
    </div>

    <button className="btn btn-primary" onClick={onSubmit}>
      Create Room →
    </button>
    <button className="btn btn-ghost" onClick={onBack}>
      ← Back
    </button>
  </div>
);

export default CreateScreen;